
import tableTemplate from './table.njk';
import tableTemplate2 from "./table2.njk"

export class UtilsWeb{
    constructor(){}
    /**
     * 
     * @param data array of objects 
     * @param column optional array of keys used in the header
     */
    static printTable(data,column){
        var header = (column) ? column : Object.keys(data[0]);
        var rows = data.map(d =>Object.values(d)  );   // #COMMENT !! should order according to header ! 
        var context = {header, rows}
        var str = tableTemplate.render(context);
        return str;
    }

    /**
     * 
     * @param data array of values to display in order
     */
    static printTable2(data){
        var context = {rows: data};
        var str = tableTemplate2.render(context);
        return str;
    }

    static strToNode(str){     //#COMMENT to deprecate for strNodeList 
        var parser = new DOMParser();
        var node = parser.parseFromString(str,'text/html').childNodes[0]   // 10-05-2020
        return node;
    }
    
    
    static strToNodeList(str){  // rename printWeb, or getNodeList
        var parser = new DOMParser();
        // var node = parser.parseFromString(str,'text/html').childNodes[0]   // 10-05-2020
        var nodeList = parser.parseFromString(str,'text/html').body.childNodes;
        return nodeList;
    }

    static printWeb(str){  
        var nodeList = UtilsWeb.strToNodeList(str);
        return nodeList;
        /*
        if (nodeList.length > 1 ) return nodeList;
        else return nodeList[0];     // TMP not a good idea to return different types 
        */
    }

    static strToDocument(str){ // rename printWeb2 or getDocument
        var parser = new DOMParser();
        var document = parser.parseFromString(str,'text/html');
        return document;
    }

    static getDocumentFragment(str){  
        var fragment = document.createDocumentFragment();
        var nodeList = UtilsWeb.getNodeList(str);
        while(nodeList.length){
            fragment.append(nodeList[0]);
        }
        return fragment;
    }

    static strToHtmlElements(str){ return UtilsWeb.strToNodeList(str) }

    static setDomOptions(node, domOptions){
        var domOptions = domOptions || {};
        if (domOptions.style){
            var strStyle = UtilsWeb.serializeObject(domOptions.style); 
            node.setAttribute('style',strStyle)
        }
        if (domOptions.classList) domOptions.classList.forEach(className => node.classList.add(className));
        if (domOptions.id) node.setAttribute('id',domOptions.id);
    }

    static serializeObject(object){
        var str = '';
        Object.entries(object).forEach(([k,v])=> str+= `${k}:${v}`)
        return str;
    }

}